/**
 *
 * @author Matthew Rawson @ 13/09/2018 11:46
 * @description
 * @notes
 */
import React, {Fragment, PureComponent} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import moment from "moment"
import {get} from "lodash"

import id from "@irati/utils/id/index"
import {FormattedDate, FormattedMessage} from "@irati/utils/lang/index"

import {Para} from "../../ui/Labels/index"


const Cell = styled.div`
  display: flex;
  align-items: center;
`
const WrappedPara = styled(Para)`
  white-space: normal;
`


class DateRangeCellRenderer extends PureComponent {
  static propTypes = {
    row: PropTypes.object,
    fromAccessor: PropTypes.string,
    toAccessor: PropTypes.string
  }
  static defaultProps = {
    row: {},
    fromAccessor: "data.from",
    toAccessor: "data.to"
  }


  constructor(props) {
    super(props)
    this.state = {}
  }


  render() {
    const idNamespace = id("DriverCellRenderer", this.props)
    const {row, fromAccessor, toAccessor} = this.props
    const from = moment(get(row, fromAccessor))
    const to = moment(get(row, toAccessor))
    const isAllTime = !from.isValid() || !to.isValid()

    return (
      <Cell id={idNamespace}>
        <WrappedPara medium flush>
          {isAllTime && (
            <FormattedMessage id="insights.renderers.dateRange.allTime" />
          )}

          {!isAllTime && (
            <Fragment>
              <FormattedDate value={from} />
              <span> - </span>
              <FormattedDate value={to} />
            </Fragment>
          )}
        </WrappedPara>
      </Cell>
    )
  }
}

export default DateRangeCellRenderer
